import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Broadcasting from "@/components/Broadcasting";
import Process from "@/components/Process";
import Why from "@/components/Why";
import Gallery from "@/components/Gallery";
import Clients from "@/components/Clients";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

const STATIC_MODE = process.env.REACT_APP_STATIC_CONTENT === 'true';

export default function Home() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        if (STATIC_MODE) {
          const res = await fetch('/data/content.json');
          setData(await res.json());
        } else {
          const res = await api.get("/public/home");
          setData(res.data);
        }
      } catch (e) { console.error("home data fail", e); }
      finally { setLoading(false); }
    })();
  }, []);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base">
        <div className="text-mute text-[13px] tracking-wider">Cargando…</div>
      </div>
    );
  }
  const { content = {}, services = [], photos = [], clients = [] } = data || {};
  const whatsapp = content?.contact?.whatsapp || "5491166861309";
  return (
    <div id="top" className="relative min-h-screen bg-base">
      <NavBar />
      <main>
        <Hero content={content} stats={content?.stats || []} photos={photos} />
        <Services services={services} whatsapp={whatsapp} />
        <About content={content} photos={photos} />
        <Broadcasting content={content} photos={photos} whatsapp={whatsapp} />
        <Process content={content} />
        <Why content={content} />
        <Gallery photos={photos} content={content} />
        <Clients clients={clients} />
        <Contact content={content} />
      </main>
      <Footer content={content} />
      <WhatsAppFab phone={whatsapp} />
    </div>
  );
}
